import makeStyles from '@mui/styles/makeStyles';
const myAccountGenericInputStyles = makeStyles(({ palette, breakpoints }) => ({
    root: {
        borderRadius: 0,
        background: palette.common.white,
        '& legend': {
            display: 'none',
        },
        '& fieldset': {
            top: 0,
        },
        '&.Mui-disabled': {
            backgroundColor: palette.action.disabledBackground,
        },
    },
    fieldWrapper: {
        position: 'relative',
        width: '100%',
    },
    input: {
        width: '100%',
        '& input': {
            width: '100%',
            height: 'fit-content',
            '&.Mui-disabled': {
                WebkitTextFillColor: palette.common.black,
            },
        },
    },
    phoneInput: {
        '& input': {
            marginLeft: 12,
        },
    },
    errorText: {},
    notchedOutline: {
        borderRadius: 0,
        borderWidth: 1,
        '& span': {
            display: 'none',
        },
    },
    focused: {
        borderColor: palette.primary.main,
    },
    inputError: {
        borderColor: palette.error.main,
    },
    dateCalendar: {
        '& span': {
            color: palette.primary.main,
        },
        [breakpoints.down(breakpoints.values.sm)]: {
            paddingRight: '10px',
        },
    },
    helperTextError: {
        margin: '4px 0',
        color: palette.error.main,
    },
    label: {
        color: palette.text.primary,
        marginBottom: 6,
        lineHeight: '20px',
    },
    phonePrefix: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '52px',
        width: '48px',
        backgroundColor: palette.action.disabledBackground,
    },
    noOptions: {},
    inputNoLabel: {},
    tooltipIcon: {},
    labelAsterisk: {},
    labelContainer: {},
    startAdornment: {},
    disabled: {},
}), { name: 'Common_InputWithHyphen' });
export default myAccountGenericInputStyles;
//# sourceMappingURL=inputWithHyphen.styles.js.map